enum ChatLocalMessageType {
  OFFLINE_NOTICE = "offlineNotice",
  TURN_STOPPED = "turnStopped",
  VOICE_EMPTY = "voiceEmpty", //             a recording that produced no transcript at all
  VOICE_UNAVAILABLE = "voiceUnavailable", // the microphone could not be opened
}

export default ChatLocalMessageType;
